import dayjs from "dayjs";
import { CalendarOutlined, UserOutlined, TeamOutlined, CreditCardOutlined } from "@ant-design/icons";
import { Tag } from "antd";
import { useEffect } from "react";

const STATUS_STYLE = {
    reserved: { bg: "#fff7e6", color: "#d46b08", border: "#ffd591" },
    occupied: { bg: "#f6ffed", color: "#389e0d", border: "#b7eb8f" },
    checked_out: { bg: "#f5f5f5", color: "#8c8c8c", border: "#d9d9d9" },
    cancelled: { bg: "#fff1f0", color: "#cf1322", border: "#ffa39e" },
};

export function UpcomingBookingsList({ check_in_date,bookings = [], onSelect, selectedId }) {
    const today = dayjs();

    // Only show future/upcoming — check_in is today or later, exclude currently active ones that are already shown

    console.log("selectedId----", selectedId);
    console.log("----bookings", bookings);

    // const upcoming = bookings
    const upcoming = [...bookings] // guest_status should be reserved or occupied, otherthan remove the booking from upcoming list
    .filter(b => ["reserved", "occupied"].includes(b.status))
        .sort((a, b) => b.bl_id - a.bl_id); // Descending by ID
    // .filter(b =>
    //     dayjs(b.check_in).isAfter(today, "day") ||
    //     dayjs(b.check_in).isSame(today, "day")
    // );

    // console.log("upcoming000",upcoming);

    // useEffect(() => {
    //     if (upcoming.length && !selectedId) {
    //         onSelect(upcoming[0]);
    //     }
    // }, [upcoming]);


    if (!upcoming.length) return null;

    // if(selectedId === !b.bl_id){setPaymentRows(null)}

    return (
        <div style={{ marginTop: 16 }}>
            <div style={{
                fontSize: 11, fontWeight: 700, color: "#888",
                textTransform: "uppercase", letterSpacing: 0.8,
                marginBottom: 10
            }}>
                {dayjs(check_in_date).format("DD-MM-YYYY")} Reservations ({upcoming.length})
            </div>

            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                {upcoming.map((b) => {
                    const s = STATUS_STYLE[b.status] || STATUS_STYLE.reserved;
                    const isSelected = selectedId === b.bl_id;
                    const nights = dayjs(b.check_out).diff(dayjs(b.check_in), "day");

                    return (
                        <div
                            key={b.bl_id}
                            onClick={() => onSelect(b)}
                            style={{
                                padding: "12px 14px",
                                borderRadius: 10,
                                border: isSelected
                                    ? "2px solid #1677ff"
                                    : `1px solid ${s.border}`,
                                background: isSelected ? "#e6f4ff" : s.bg,
                                cursor: "pointer",
                                transition: "all 0.15s",
                                boxShadow: isSelected ? "0 2px 8px rgba(22,119,255,0.15)" : "none",
                            }}
                        >
                            {/* Top row: name + status badge */}
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
                                <div style={{ display: "flex", alignItems: "center", gap: 7 }}>
                                    <div style={{
                                        width: 28, height: 28, borderRadius: "50%",
                                        background: "#1677ff22",
                                        display: "flex", alignItems: "center", justifyContent: "center",
                                        fontSize: 13, color: "#1677ff"
                                    }}>
                                        <UserOutlined />
                                    </div>
                                    <div>
                                        <div style={{ fontSize: 13, fontWeight: 600, color: "#1a1a1a" }}>
                                            {b.guest_name}
                                        </div>

                                        <Tag color={b.mode === "online" ? "volcano" : "default"}>
                                            {b.mode === "online" ? "Online" : "Offline"}
                                        </Tag>

                                        <div style={{ fontSize: 11, color: "#888" }}>{b.phone}</div>
                                    </div>
                                </div>
                                <span style={{
                                    fontSize: 11, fontWeight: 600,
                                    padding: "3px 10px", borderRadius: 20,
                                    background: s.bg, color: s.color,
                                    border: `1px solid ${s.border}`,
                                    textTransform: "capitalize"
                                }}>
                                    {b.status}
                                </span>
                            </div>

                            {/* Dates row */}
                            <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
                                <div style={{ display: "flex", alignItems: "center", gap: 5, fontSize: 12, color: "#555" }}>
                                    <CalendarOutlined style={{ color: "#1677ff" }} />
                                    <span>
                                        {dayjs(b.check_in).format("DD MMM YYYY")}
                                        {" → "}
                                        {dayjs(b.check_out).format("DD MMM YYYY")}
                                    </span>
                                    <span style={{
                                        marginLeft: 4, fontSize: 11,
                                        background: "#f0f0f0", borderRadius: 4,
                                        padding: "1px 6px", color: "#555"
                                    }}>
                                        {nights === 0 ? 'to' : nights} {nights === 1 ? "night" : "nights"}
                                    </span>
                                </div>
                                <div style={{ display: "flex", alignItems: "center", gap: 5, fontSize: 12, color: "#555" }}>
                                    <TeamOutlined style={{ color: "#1677ff" }} />
                                    <span>{b.guests} guest{b.guests > 1 ? "s" : ""}</span>
                                </div>
                                <div style={{ display: "flex", alignItems: "center", gap: 5, fontSize: 12, color: "#555" }}>
                                    <CreditCardOutlined style={{ color: "#1677ff" }} />
                                    <span>₹{Number(b.total_amount || 0).toLocaleString()}</span>
                                </div>
                            </div>

                            {isSelected && (
                                <div style={{
                                    marginTop: 8, fontSize: 11,
                                    color: "#1677ff", fontWeight: 600
                                }}>
                                    ✓ Selected — edit details in the form below
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
}